import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import RowAlertToastList from './RowAlertToastList.js';

const RowAlertContext = createContext(null);

// Single shared toast stack for every useNewRowAlerts() source (Intraday Base, Result
// Analysis, ...). Without this, each source rendering its own fixed bottom-right container
// would overlap the others whenever more than one had a toast up at the same time.
export const RowAlertProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const timeoutsRef = useRef({});

  const removeToast = useCallback((id) => {
    setToasts((current) => current.filter((toast) => toast.id !== id));
    clearTimeout(timeoutsRef.current[id]);
    delete timeoutsRef.current[id];
  }, []);

  const pushToasts = useCallback((newToasts, toastDurationMs) => {
    setToasts((current) => [...current, ...newToasts]);
    newToasts.forEach((toast) => {
      timeoutsRef.current[toast.id] = setTimeout(() => removeToast(toast.id), toastDurationMs);
    });
  }, [removeToast]);

  return (
    <RowAlertContext.Provider value={{ pushToasts }}>
      {children}
      <RowAlertToastList toasts={toasts} removeToast={removeToast} />
    </RowAlertContext.Provider>
  );
};

export const useRowAlertContext = () => {
  const ctx = useContext(RowAlertContext);
  if (!ctx) throw new Error('useNewRowAlerts must be used within a RowAlertProvider');
  return ctx;
};
